module.exports = __webpack_public_path__ + "img/index02.2e3eb0f6.svg";